import { Component } from '@angular/core';

@Component({
  selector: 'app-campaign-report',
  templateUrl: './campaign-report.component.html',
  styleUrls: ['./campaign-report.component.scss']
})
export class CampaignReportComponent {
  reports = [
    {
      name: "Campaigns by Status",
      description: "Provides an overview of campaigns categorized by their status such as Draft, Scheduled, Running, or Completed.",
      lastAccessed: "10 min ago",
      slug: "campaigns-by-status"
    },
    {
      name: "Campaign Type",
      description: "Displays campaigns based on type, such as Email, WhatsApp, or Call.",
      lastAccessed: "22 min ago",
      slug: "campaign-type"
    },
    {
      name: "Scheduled Campaigns",
      description: "Lists all campaigns that are scheduled for future delivery, helping in managing upcoming outreach.",
      lastAccessed: "5 min ago",
      slug: "scheduled-campaigns"
    }
  ];
}
